<template>
  <div class="pay-html">跳转支付中.....</div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},
  mounted() {
    $(".pay-html").html(localStorage.getItem("payHtml"));
  }
};
</script>

<style lang="scss" scoped>
.pay-html {
  position: fixed;
  height: 400px;
  width: 100%;
  top: 0;
  z-index: 2;
  background: #fff;
}
</style>
